/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Module_Type_Eclypseboilerroom2Inputs */



/**
* | output |
* | --- |
* | "Eclypse" |
*
* @param {Module_Type_Eclypseboilerroom2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const module_type_eclypseboilerroom2 = /** @type {((inputs?: Module_Type_Eclypseboilerroom2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Module_Type_Eclypseboilerroom2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Eclypse")
	return /** @type {LocalizedString} */ ("Eclypse")
});
export { module_type_eclypseboilerroom2 as "module_type_eclypseBoilerRoom" }